"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _mobx = require("mobx");

var _BaseTableModel2 = _interopRequireDefault(require("./BaseTableModel"));

var _TableApiStorageProvider = _interopRequireDefault(require("../storage/TableApiStorageProvider"));

var _LoadingStates = _interopRequireDefault(require("./LoadingStates"));

var _range = _interopRequireDefault(require("lodash/range"));

var _map = _interopRequireDefault(require("lodash/map"));

var _mapValues = _interopRequireDefault(require("lodash/mapValues"));

var _filter = _interopRequireDefault(require("lodash/filter"));

var _includes = _interopRequireDefault(require("lodash/includes"));

var _forEach = _interopRequireDefault(require("lodash/forEach"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _extend = _interopRequireDefault(require("lodash/extend"));

var _pickBy = _interopRequireDefault(require("lodash/pickBy"));

var _reverse = _interopRequireDefault(require("lodash/reverse"));

var _queryString = _interopRequireDefault(require("query-string"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

var DynamicTableModel = (_class = /*#__PURE__*/function (_BaseTableModel) {
  _inherits(DynamicTableModel, _BaseTableModel);

  var _super = _createSuper(DynamicTableModel);

  function DynamicTableModel(props) {
    var _this;

    _classCallCheck(this, DynamicTableModel);

    _this = _super.call(this, props);

    _initializerDefineProperty(_assertThisInitialized(_this), "cacheData", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "requestId", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "recordCount", _descriptor3, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "loadState", _descriptor4, _assertThisInitialized(_this));

    _this.loadState = props.loadState || _LoadingStates.default.DATA_REFRESH_NEEDED;
    _this.dispatcher = null;
    _this.baseEndpoint = props.endpoint || "";
    _this.storageProvider = new _TableApiStorageProvider.default(_this.baseEndpoint);
    return _this;
  }

  _createClass(DynamicTableModel, [{
    key: "currentData",
    get: function get() {
      var cacheKey = this.generatedCacheKey;

      if (!this.existsInCache(cacheKey, this.currentPage)) {
        return [];
      }

      return this.cacheData.get(cacheKey)[this.currentPage];
    }
  }, {
    key: "currentFilterState",
    get: function get() {
      var filterState = {
        pageSize: this.itemsPerPage
      }; // filters is a Mobx object

      this.filters.forEach(function (filterDefinition, filterKey) {
        // eslint-disable-line lodash/prefer-lodash-method
        if (filterDefinition.value) {
          filterState[filterKey] = filterDefinition.value;
        }
      });
      var sortDefinitions = (0, _reverse.default)(this.sorts.slice());
      (0, _forEach.default)(sortDefinitions, function (sortDefinition, index) {
        var columnKey = "sort[".concat(index, "].iteratee");
        var orderKey = "sort[".concat(index, "].order");
        filterState[columnKey] = sortDefinition.iteratee;
        filterState[orderKey] = sortDefinition.descending ? "desc" : "asc";
      });
      return filterState;
    }
  }, {
    key: "generatedCacheKey",
    get: function get() {
      return _queryString.default.stringify(this.currentFilterState);
    }
  }, {
    key: "currentEndpoint",
    get: function get() {
      if ((0, _isEmpty.default)(this.baseEndpoint)) {
        return "";
      }

      var queryParams = this.currentFilterState;
      var pages = (0, _range.default)(Math.max(0, this.currentPage - 2), this.currentPage + 3);
      var currentCache = this.cacheData.get(this.generatedCacheKey);

      if (currentCache) {
        pages = (0, _filter.default)(pages, function (pageIndex) {
          return !currentCache[pageIndex];
        });
      }

      queryParams.pages = pages;
      queryParams.requestId = this.requestId;
      return this.baseEndpoint + ((0, _includes.default)(this.baseEndpoint, "?") ? "&" : "?") + _queryString.default.stringify(queryParams);
    }
  }, {
    key: "pageCount",
    get: function get() {
      return Math.ceil(this.recordCount / this.itemsPerPage);
    }
  }, {
    key: "isLoaded",
    get: function get() {
      return this.loadState === _LoadingStates.default.DATA_LOADED;
    }
  }, {
    key: "changePage",
    value: function changePage(newPage) {
      this.currentPage = newPage;
      this.refreshTable();
    }
  }, {
    key: "refreshTable",
    value: function refreshTable() {
      if (this.existsInCache(this.generatedCacheKey, this.currentPage)) {
        var endpointSpecificCache = this.cacheData.get(this.generatedCacheKey);
        this.recordCount = endpointSpecificCache.recordCount;
      } else {
        this.retrievePagesFromServer();
      }
    }
  }, {
    key: "clearCache",
    value: function clearCache() {
      this.cacheData.clear();
      this.refreshTable();
    }
  }, {
    key: "updateItemsPerPage",
    value: function updateItemsPerPage(newPageSize) {
      _get(_getPrototypeOf(DynamicTableModel.prototype), "updateItemsPerPage", this).call(this, newPageSize);

      this.refreshTable();
    }
  }, {
    key: "updateSort",
    value: function updateSort(columnName) {
      _get(_getPrototypeOf(DynamicTableModel.prototype), "updateSort", this).call(this, columnName);

      this.refreshTable();
    }
  }, {
    key: "updateFilter",
    value: function updateFilter(filterKey, newValue) {
      _get(_getPrototypeOf(DynamicTableModel.prototype), "updateFilter", this).call(this, filterKey, newValue);

      if (!this.filters.get(filterKey).isNoOp) {
        this.refreshTable();
      }
    }
  }, {
    key: "insertIntoCache",
    value: function insertIntoCache(cacheKey, pagesToBeInserted) {
      var pageData = (0, _extend.default)({}, this.cacheData.get(cacheKey), pagesToBeInserted);
      var tempCacheToBeMerged = {};
      tempCacheToBeMerged[cacheKey] = pageData;
      this.cacheData.merge(tempCacheToBeMerged);
    }
  }, {
    key: "existsInCache",
    value: function existsInCache(cacheKey, page) {
      if (this.cacheData.get(cacheKey) !== undefined) {
        var cache = this.cacheData.get(cacheKey);

        if (cache.recordCount === 0) {
          // must explicitly check for an empty record set as it will have no pages and Boolean(cache[page]) would return false.
          return true;
        }

        return Boolean(cache[page]);
      }

      return false;
    }
  }, {
    key: "retrievePagesFromServer",
    value: function retrievePagesFromServer() {
      var _this2 = this;

      // We don't do the retrieval right away in case the View is not ready (i.e. elements are not mounted in the DOM yet),
      // instead, we set a flag for the View to see, so it knows to trigger the retrieval when it's ready
      if (this.loadState === _LoadingStates.default.UI_NOT_READY || this.loadState === _LoadingStates.default.DATA_REFRESH_NEEDED) {
        this.loadState = _LoadingStates.default.DATA_REFRESH_NEEDED;
        return;
      } // Force handle one search request at a time, GR-6954


      if (this.loadState === _LoadingStates.default.DATA_LOADING) {
        return;
      } // If you get here, the View is ready (and potentially called this method), so it's safe to do the retrieval


      this.loadState = _LoadingStates.default.DATA_LOADING;
      this.requestId++;
      this.storageProvider.endpoint = this.currentEndpoint;
      this.storageProvider.get(this.dispatcher, (0, _mobx.action)(function (res) {
        if (_this2.requestId > res.body.requestId) {
          return;
        }

        _this2.sorts = (0, _reverse.default)((0, _map.default)(res.body.sort, function (sortDefinition, index) {
          return {
            iteratee: sortDefinition.iteratee,
            descending: sortDefinition.order === "desc",
            primary: index === 0
          };
        }));
        var pagesToInclude = (0, _pickBy.default)(res.body.results, function (pageEntries) {
          return !(0, _isEmpty.default)(pageEntries);
        });
        pagesToInclude = (0, _mapValues.default)(pagesToInclude, function (pageContents, pageNumber) {
          return (0, _map.default)(pageContents, function (row) {
            return _this2.createRowModel(row);
          });
        });
        pagesToInclude.recordCount = res.body.recordCount;
        _this2.recordCount = res.body.recordCount;

        _this2.insertIntoCache(_this2.generatedCacheKey, pagesToInclude);

        _this2.loadState = _LoadingStates.default.DATA_LOADED;
      }));
    }
  }]);

  return DynamicTableModel;
}(_BaseTableModel2.default), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "cacheData", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return _mobx.observable.map({});
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "requestId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "recordCount", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "loadState", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "currentData", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentFilterState", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentFilterState"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "generatedCacheKey", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "generatedCacheKey"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentEndpoint", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentEndpoint"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pageCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "pageCount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isLoaded", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isLoaded"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "changePage", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "changePage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "refreshTable", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "refreshTable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearCache", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "clearCache"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateItemsPerPage", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateItemsPerPage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateSort", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateSort"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateFilter", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateFilter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertIntoCache", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "insertIntoCache"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "retrievePagesFromServer", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "retrievePagesFromServer"), _class.prototype)), _class);
var _default = DynamicTableModel;
exports.default = _default;